import { useState } from "react";
import { useLocation } from "wouter";
import { PanelsTopLeft, CheckSquare, Clock, Menu } from "lucide-react";
import { useIsMobile } from "@/hooks/use-mobile";
import MoreMenu from "./MoreMenu";

const tabs = [
  { key: "home", label: "Home", icon: PanelsTopLeft, path: "/" },
  { key: "tasks", label: "Tasks", icon: CheckSquare, path: "/my-tasks" },
  { key: "timesheet", label: "Timesheet", icon: Clock, path: "/timesheet" },
  { key: "more", label: "More", icon: Menu, path: null },
] as const;

const hiddenRoutes = ["/login", "/signup", "/on-hold"];

export default function BottomTabBar() {
  const isMobile = useIsMobile();
  const [location, navigate] = useLocation();
  const [moreMenuOpen, setMoreMenuOpen] = useState(false);

  if (!isMobile) return null;
  if (hiddenRoutes.includes(location)) return null;

  const isTabActive = (tab: (typeof tabs)[number]) => {
    if (tab.key === "more") return moreMenuOpen;
    if (tab.path === "/") return location === "/";
    return location === tab.path || location.startsWith(tab.path + "/");
  };

  const handleTabPress = (tab: (typeof tabs)[number]) => {
    if (tab.key === "more") {
      setMoreMenuOpen(true);
      return;
    }
    if (tab.path) {
      navigate(tab.path);
    }
  };

  return (
    <>
      <nav className="fixed bottom-0 left-0 right-0 z-50 bg-background border-t border-border shadow-[0_-2px_10px_rgba(0,0,0,0.05)] pb-[env(safe-area-inset-bottom)]">
        <div className="flex items-center justify-around h-16">
          {tabs.map((tab) => {
            const active = isTabActive(tab);
            const Icon = tab.icon;
            return (
              <button
                key={tab.key}
                onClick={() => handleTabPress(tab)}
                className={`flex flex-col items-center justify-center gap-0.5 flex-1 h-full transition-colors duration-200 relative ${
                  active ? "text-primary" : "text-muted-foreground"
                }`}
              >
                {active && (
                  <span className="absolute top-1 w-4 h-0.5 rounded-full bg-primary" />
                )}
                <Icon className="h-5 w-5" />
                <span className="text-[10px] font-medium">{tab.label}</span>
              </button>
            );
          })}
        </div>
      </nav>

      <MoreMenu open={moreMenuOpen} onOpenChange={setMoreMenuOpen} />
    </>
  );
}
